<template>
  <div :class="[baseCss, animation === 'wave' ? 'relative' : null, `${baseCss}-animation-${animation}`, block ? 'block' : 'inline-block', 'select-none', 'overflow-hidden', `rounded-${rounded}`, `shadow-${elevation}`, type === 'circle' ? 'rounded-full' : null, `${baseCss}-${type}`, setBgColor()]" :style="{'--gradient-color': animationWaveGradientColor, width, verticalAlign: 'middle', height: type === 'circle' ? width : height}" />
</template>
<script>
import props from '../../mixins/props'
import methods from '../../mixins/methods'

export default {
  name: 'SkeletonLoader',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('skeleton-loader', [])
    }
  },
  props: {
    block: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'rectangle',
      validator: value => {
        return ['circle', 'rectangle'].includes(value)
      }
    },
    rounded: {
      type: String,
      default: 'none',
      validator: value => {
        return ['sm', 'md', 'lg', 'full', 'none'].includes(value)
      }
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '64px'
    },
    bgColor: {
      type: String,
      default: 'gray'
    },
    bgColorLightness: {
      type: Number,
      default: 300
    },
    animation: {
      type: String,
      default: 'fade',
      validator: value => {
        return ['wave', 'fade', 'pulse', 'pulse-x', 'pulse-y', 'none'].includes(value)
      }
    },
    animationWaveGradientColor: {
      type: String,
      default: 'rgba(255, 255, 255, .5)'
    }
  }
}
</script>
<style>
.bcq-skeleton-loader.bcq-skeleton-loader-animation-wave::before
{
  content: '';
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

@keyframes bcq-skeleton-loader-fade
{
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}

@keyframes bcq-skeleton-loader-pulse
{
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.85);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes bcq-skeleton-loader-pulse-x {
  0% {
    transform: scaleX(1);
  }
  50% {
    transform: scaleX(0.75);
  }
  100% {
    transform: scaleX(1);
  }
}

@keyframes bcq-skeleton-loader-pulse-y {
  0% {
    transform: scaleY(1);
  }
  50% {
    transform: scaleY(0.75);
  }
  100% {
    transform: scaleY(1);
  }
}

@keyframes bcq-skeleton-loader-wave {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.bcq-skeleton-loader-animation-fade
{
  animation: bcq-skeleton-loader-fade 1.5s linear .5s infinite;
}

.bcq-skeleton-loader-animation-wave::before
{
  background: linear-gradient(90deg, transparent, var(--gradient-color), transparent);
  animation: bcq-skeleton-loader-wave 1.5s linear .5s infinite;
}

.bcq-skeleton-loader-animation-pulse-x
{
  animation: bcq-skeleton-loader-pulse-x 1.5s linear .5s infinite;
}

.bcq-skeleton-loader-animation-pulse-y
{
  animation: bcq-skeleton-loader-pulse-y 1.5s linear .5s infinite;
}

.bcq-skeleton-loader-animation-pulse
{
  animation: bcq-skeleton-loader-pulse 1.5s linear .5s infinite;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/skeleton-loader/skeleton-loader.vue